import React from 'react';
import { RichText } from 'volto-essvoltocomponents/components/Atoms';
import PageHeaderSimple from '../../Molecules/PageHeaderSimple';
import { buildCitation } from './publicationUtils';  
import {
  ContentWide,
  ContentWrapper,
  PageSection
} from 'volto-essvoltocomponents/components/Layout';

const PublicationItemView = ({ content }) => {
  // build a citation string once so we can test its presence
  const citation = buildCitation(content);

  return (
    <>
      <PageHeaderSimple
        title={content.title}
        showBackButton={true}
        goBackText="Go back"
      />
      <PageSection paddingTop="var(--ess-space-2xl)" paddingBottom="var(--ess-space-2xl)">
        <ContentWrapper>
            {/* Summary */}
            {content?.description?.data && (
              <ContentWide className="publication-abstract">
                <b>Abstract: </b>
                <RichText content={content.description.data}/>
              </ContentWide>
            )}
            {/* Metadata */}
            {citation && (
              <ContentWide 
                className="publication-metadata"
                alignment='left'>
                  <RichText content={citation}/>
              </ContentWide>
            )}

            {/* Type */}
            {content?.publication_type && (
              <ContentWide 
                className="publication-type" 
                alignment='left'
                style={{flexDirection: "row"}}>
                  <b>Type: </b>
                  <span>{content.publication_type.title} </span> 
              </ContentWide>
            )}
        </ContentWrapper>
      </PageSection>
    </>
  );
};

export default PublicationItemView;
